module.exports = __webpack_public_path__ + "static/media/back-in-stock.c1ca1811.jpg";